/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface EnterpriseCustomerV2Dto {
  active?: boolean;
  address?: string;
  city?: string;
  color?: string;
  comment?: string;
  contactPerson?: string;
  country?: string;
  deleted?: boolean;
  email?: string;
  externalId?: string;
  id?: number;
  mobilePhone?: string;
  name?: string;
  owner?: EnterpriseIdDto;
  phone?: string;
  postcode?: string;
  totalAreaFields?: number;
  totalAreaLocations?: number;
  updated?: string;
  ustId?: string;
}
